export default __webpack_public_path__ + "static/media/b3c0b826082d21c3960050971c359503.png";